import 'regenerator-runtime/runtime'


Office.initialize = () => {
  console.log('office.initialized')
}
